export default class PlayroomCustomFeature {
  id!: string;
  sortOrder!: number;
  playroomId!: string;
  customName!: string;
  hasFee!: boolean;
}
